import * as api from "@/api";
import router from "@/router";
import { formatPhone } from "@/utils/helpers";
import { getYear } from "date-fns";
import { FL_VALUE, IP_VALUE, UL_VALUE } from "@/utils/opfTypes";
import { FIXED_VALUE, PROGRESSIVE_VALUE } from "@/utils/rewardTypes";

const initState = () => ({
  user_group: null,
  referral_landing_url: "",
  phone: "",
  firstname: "",
  surname: "",
  middlename: "",
  email: "",
  acc: "",
  tax_type: "",
  vat: null,
  type: null,
  reward_type: "",
  inn: "",
  showStepper: false, // для отображения 3-го шага степпера
  ogrnExist: false,
  companyFound: false,
  bank: null,
  company: null,
  profile_id: "",
  files: [],
  // staff: [], // переехали в свой модуль employes
  access: [],
  showPopup: true,
  unchangeable_fields: null,
  company_name: "",
  popupModulBic: false,
  popupNoModulBic: false,
  showRatingPanel: false,
  canSeeRating: false,
  partner_rating: null,
  conversion_score: null,
  profit_score: null,
  active_score: null,
  quality_score: null,
  subcategory_reward: null,
  left_to_calculate: null,
  possible_activity: null,
});

export default {
  namespaced: true,
  state: initState,
  getters: {
    bic: ({ bank }) => bank && bank.bic,
    acc: ({ acc }) => acc.replace(/\D/g, ""),
    inn: ({ inn, company }, { isFL }) => (isFL ? inn : company && company.inn),
    vat: ({ vat }) => vat,

    //рейтинг
    partner_rating: (state) => Math.floor(state.partner_rating * 100),
    conversion_score: (state) => Math.floor(state.conversion_score * 100),
    profit_score: (state) => Math.floor(state.profit_score * 100),
    active_score: (state) => Math.floor(state.active_score * 100),
    quality_score: (state) => Math.floor(state.quality_score * 100),
    subcategory_reward: (state) => state.subcategory_reward,
    left_to_calculate: (state) => state.left_to_calculate,
    canSeeRating: (state) => state.canSeeRating,

    // Форматирование
    formattedPhone: ({ phone }) => formatPhone(phone),

    // Тип "лица"
    isUL: ({ type }) => type === UL_VALUE || type === IP_VALUE,
    isFL: ({ type }) => type === FL_VALUE,

    // Степпер
    // Здесь проверяем type для "старых" юзеров, т.к. может не быть фио, но type должен быть
    isFirstStepComplete: ({ possible_activity }) =>
      !(possible_activity?.window?.registration_form?.required && possible_activity?.registration_form?.person?.required),

    isSecondStepComplete: ({ possible_activity }) =>
      !(possible_activity?.window?.registration_form?.required && possible_activity?.registration_form?.profile?.required),

    isRegistrationSurveyStepComplete: ({ possible_activity }) => {
      const showRegistrationForm = possible_activity?.window?.registration_form?.required ?? false;
      return !(showRegistrationForm && possible_activity?.registration_form?.registration_survey?.required);
    },

    // Степпер показываем только партнерам (не сотрудникам),
    // если не заполнены дланные с 1 или 2 шага или стоит метка showStepper для третьего шага
    isRegStepper: ({ showStepper }, { isFirstStepComplete, isSecondStepComplete, isRegistrationSurveyStepComplete, isPartner }) =>
      (!isFirstStepComplete || !isSecondStepComplete || !isRegistrationSurveyStepComplete || showStepper) && isPartner,

    // Загружены ли файлы
    isFilesAdded: ({ files }, { isUL, isFL }) =>
      Array.isArray(files) && (isUL ? files.length === 2 : isFL ? files.length === 3 : false),

    // Проверка на заполненность профиля

    /*
    // ЮЛ реквизиты + доки
    ulReqIsNotFilled: ({ bank, acc, tax_type, files }, { isUL }) =>
      isUL && (!bank || !acc || !tax_type || !Array.isArray(files) || files.length < 2),
    ulReqIsNotFilled: ({ bank, acc, tax_type, files }, { isUL }) =>
      isUL && (!bank || !acc || !tax_type || !Array.isArray(files) || files.length < 2),
    // ФЛ реквизиты + доки
    flReqIsNotFilled: ({ bank, acc, files }, { isFL }) =>
      isFL && (!bank || !acc || !Array.isArray(files) || files.length < 3),
    */

    // ФЛ ФИО
    flNameIsNotFilled: ({ firstname, surname, middlename }, { isFL }) =>
      isFL && (!firstname || !surname || !middlename),

    extraReqIsNotFilled: ({ possible_activity: { requisites_form } }) =>
      Boolean(requisites_form?.extra_requisites?.advice),

    // реквизиты + доки в общем
    reqIsNotFilled: ({ possible_activity: { requisites_form } }, { extraReqIsNotFilled }) =>
      Boolean(requisites_form?.common?.advice) || extraReqIsNotFilled,

    // Проверка заполненности профиля без учета доков для возможности вывода денег без доков (временно??)
    ulNotFilled: ({ bank, acc, tax_type }, { isUL }) => isUL && (!bank || !acc || !tax_type),
    flNotFilled: ({ bank, acc }, { isFL }) => isFL && (!bank || !acc),

    // Проверка RegStepper на 2 шаге новое условие по параметру - company_name
    shouldShowCompanyDetailsForm: ({ company }, { isUL }) =>
      isUL && company && (!company.name || !company.ogrn || !company.inn),

    // Вывод денег запрещен если не заполнены реквизиты или ФИО ФЛ
    cantWithdraw: (state, { ulNotFilled, flNotFilled, flNameIsNotFilled }) =>
      ulNotFilled || flNotFilled || flNameIsNotFilled,

    // Проверка что текущий юзер является партнером (не сотрудником)
    isPartner: ({ user_group }) => user_group === "partner",

    // Проверка что юзер не на архивном тарифе (для показа формы смены модели вознаграждения в настройках)
    isActualTarif: ({ reward_type }) => reward_type === PROGRESSIVE_VALUE || reward_type === FIXED_VALUE,

    // Попап
    showPopup: (state, getters) => {
      let dontShowPopup = false;
      try {
        dontShowPopup = window.localStorage.getItem("dont_show_dec_new_popup");
      } catch (error) { }
      return state.showPopup && getters.isPartner && !dontShowPopup;
    },

    canSeeNewOffertaPopup: ({ access }) => access.includes("agent.profile.update_agreement"),

    // TODO: make access contsts
    // Доступы
    canSeeAutoCreditTab: ({ access }) => access.includes("initiate_flex_solo"),
    canSeeManagerApps: ({ access }) => access.includes("agent.app.manager_list"),
    canSeeMeetings: ({ access }) => access.includes("agent.meeting.list"),
    canSeeProcess: ({ access }) => access.includes("agent.meeting.process"),
    canMeetingPlace: ({ access }) => access.includes("agent.meeting.reserve"),
    canAddMeetingComment: ({ access }) => access.includes("agent.meeting.add_comment"),
    canSeeTeam: ({ access }) => access.includes("agent.subpartner.list"),
    canSendInvite: ({ access }) => access.includes("agent.subpartner.invite"),
    canManagePromos: ({ access }) => access.includes("management.promotion.list"),
    canAddUser: ({ access }) => access.includes("agent.employee.add"),
    canCreateApp: ({ access }) => access.includes("agent.app.add"),
    canSeeApps: ({ access }) => access.includes("agent.app.list"),
    canSeePayouts: ({ access }) => access.includes("billing.demand_payouts.list"),
    canLoadApps: ({ access }) => false, // TODO
    canSeeBilling: ({ access }) => access.includes("billing.payments.list"),
    canSeeBonuses: ({ access }) => access.includes("agent.bonuses.goods") && access.includes('agent.bonuses.order'),
    canSeeRefresh: ({ access }) => access.includes("agent.background.refresh"),
    // Доступ вывода денег
    haveAccessToWithdraw: ({ access }) => access.includes("billing.payments.demand"),
    haveAccessToConclusion: ({ access }) => access.includes("billing.payments.demand"),
    // Старый юзер, который не поменял логин на телефонный номер имеет право: "users.account.transfer"
    // Таким юзерам показываем попап для смены логина при входе или попытке его смены
    isTransfered: ({ access }) => !access.includes("users.account.transfer"),

    waitPersonConfirm: ({ access }) => access.includes("wait_person_confirm"),
    requireChangePassword: ({ access }) => access.includes("require_change_password"),
    canSearchBank: ({ access }) => access.includes("agent.misc.search_bic"),
  },

  mutations: {
    setOgrnExist: (state, payload) => (state.ogrnExist = payload),
    setShowStepper: (state, payload) => (state.showStepper = payload),
    setBank: (state, bank) => (state.bank = bank),
    setAccess: (state, payload) => (state.access = payload.map((access) => access.obj || access.name || access)),
    setUnchangeableFields: (state, payload) => (state.unchangeable_fields = payload),

    showRating: (state, payload) => (state.canSeeRating = payload),
    showRatingPanel: (state, payload) => (state.showRatingPanel = payload),
    setRating: (state, partner_rating) => (state.partner_rating = partner_rating),
    setConversation: (state, conversion_score) => (state.conversion_score = conversion_score),
    setProfit: (state, profit_score) => (state.profit_score = profit_score),
    setActive: (state, active_score) => (state.active_score = active_score),
    setQuality: (state, quality_score) => (state.quality_score = quality_score),
    setSubcategoryReward: (state, subcategory_reward) => (state.subcategory_reward = subcategory_reward),
    setLeftToCalculate: (state, left_to_calculate) => (state.left_to_calculate = left_to_calculate),

    setPossibleActivity: (state, data) => (state.possible_activity = data),

    set: (state, payload) => (state[payload.type] = payload.value),
    // TODO: эта мутация не нужна
    addFile: (state, payload) => {
      if (!Array.isArray(state.files)) {
        state.files = [];
      }
      state.files.push(payload);
    },
    removeFile: (state, id) => {
      state.files = state.files.filter((file) => file.id !== id);
    },
    reset: (state) => {
      const initialState = initState();
      Object.keys(initialState).forEach((key) => (state[key] = initialState[key]));
    },
    closePopup: (state) => (state.showPopup = false),
    setModulBicPopup: (state, popup) => (state.popupModulBic = popup),
    setNoModulBicPopup: (state, popup) => (state.popupNoModulBic = popup),
  },

  actions: {
    // установка данных профиля из ответа сервера
    setProfile({ commit, dispatch, getters: { canSearchBank } }, res) {

      if (res.unchangeable_fields) {
        commit("setUnchangeableFields", res.unchangeable_fields);
      }
      if (res.profile_id) {
        commit("set", { type: "profile_id", value: res.profile_id });
      }
      if (res.firstname) {
        commit("set", { type: "firstname", value: res.firstname });
      }
      if (res.surname) {
        commit("set", { type: "surname", value: res.surname });
      }
      if (res.middlename) {
        commit("set", { type: "middlename", value: res.middlename });
      }
      if (res.email) {
        commit("set", { type: "email", value: res.email });
      }
      if (res.type) {
        commit("set", { type: "type", value: res.type });
      }
      if (res.referral_landing_url) {
        commit("set", { type: "referral_landing_url", value: res.referral_landing_url });
      }
      if (res.bic && canSearchBank) { // FIXME: научиться кэшировать
        dispatch("searchBank", res.bic);
      }
      if (res.acc) {
        commit("set", { type: "acc", value: res.acc });
      }
      if (res.tax_type) {
        commit("set", { type: "tax_type", value: res.tax_type });
      }

      commit("set", { type: "vat", value: res?.vat });

      if (res.reward_type) {
        commit("set", { type: "reward_type", value: res.reward_type });
      }
      if (res.phone) {
        commit("set", { type: "phone", value: res.phone });
      }
      if (res.rating_values) {
        if (res.rating_values !== null) commit("showRating", true);

        if (res.rating_values.partner_rating) commit("setRating", res.rating_values.partner_rating);
        if (res.rating_values.conversion_score) commit("setConversation", res.rating_values.conversion_score);
        if (res.rating_values.profit_score) commit("setProfit", res.rating_values.profit_score);
        if (res.rating_values.clientsActive_score) commit("setActive", res.rating_values.clientsActive_score);
        if (res.rating_values.clientsQuality_score) commit("setQuality", res.rating_values.clientsQuality_score);

        commit("setLeftToCalculate", res.rating_values.left_to_calculate);
        commit("setSubcategoryReward", res.rating_values.subcategory_reward);
      }
      if (res.type === FL_VALUE) {
        if (res.inn) {
          commit("set", { type: "inn", value: res.inn });
        }
      } else {
        let company = null;
        if (res.inn) {
          if (!company) company = {};
          company.inn = res.inn;
        }
        if (res.company_name) {
          if (!company) company = {};
          company.name = res.company_name;
        }
        if (res.ogrn) {
          if (!company) company = {};
          company.ogrn = res.ogrn;
        }
        if (company) {
          commit("set", { type: "company", value: company });
        }
      }
      if (res.possible_activity) {
        commit("setPossibleActivity", res.possible_activity);
      }

      if (Array.isArray(res.files)) {
        commit("set", {
          type: "files",
          value: res.files.map((file) => ({
            ...file,
            id: file.fileid,
          })),
        });
      } else {
        // Необходимо устанавливать пустой массив, когда удаляем последний файл
        commit("set", { type: "files", value: [] });
        // Диспатчим алерт если неправильный тип
        if (res.files !== null && res.files !== undefined) {
          dispatch(
            "common/addAlert",
            {
              msg: `Ошибка типа данных в поле files, тип ${typeof res.files} недопустим`,
              type: "error",
            },
            { root: true }
          );
        }
      }

      if (res.user_group) {
        commit("set", { type: "user_group", value: res.user_group });
      }
    },

    // получение данных профиля с сервера
    async get({ dispatch, commit }) {
      const res = await api.get();
      if (res) {
        dispatch("setProfile", res);
      }
    },

    // общий метод обновления
    async updateProfile({ dispatch, commit }, { leaveStepper, ...data }) {
      const res = await api.update(data);
      if (res) {
        // для перехода на 3 этап реги устанавливаем флаг showStepper
        commit("setShowStepper", !leaveStepper);
        dispatch("setProfile", res);
      }

      // TODO: если не нужно, удалить.
      return res;
    },

    async searchBank({ commit }, bic) {
      const res = await api.searchBank(bic);
      let bank;

      if (res?.results) {
        bank = res.results.find((bank) => bank.bic === bic);
      } else {
        console.error("Банк соответствующий БИК: " + bic + " не найден");
      }

      if (!bank) {
        bank = { bic, bank: "" };
      }

      commit("setBank", bank);
      commit("set", { type: "companyFound", value: true });
    },

    async updateBankInfo({ commit, dispatch, state: { bank, tax_type }, getters: { isUL, acc } }) {
      const data = { bank: bank.bank, bic: bank.bic || "", acc };
      if (isUL) {
        data.tax_type = tax_type;
      }
      const res = await api.update(data);
      if (res) {
        commit("setShowStepper", false);
        dispatch("setProfile", res);
        dispatch("get");
        dispatch("bid/getBids", null, { root: true });
        router.push({ path: "/cabinet/main" });
      }
    },

    async addFile({ dispatch }, { id, name, oid }) {
      const res = await api.addFile(id, name, oid);
      if (res) {
        // Получаем данные с новым массивом файлов
        dispatch("get");
      }
    },

    async deleteFile({ dispatch, getters }, id) {
      const res = await api.deleteFile(id, getters.profile_id);
      if (res) {
        // Получаем данные с новым массивом файлов
        dispatch("get");
      }
    },
  },
};
